import { FormGroup, Text } from '@cmctechnology/phoenix-stockbroking-web-design';
import styled from 'styled-components';

export const FormGroupSubLabelWithoutTopMargin = styled(FormGroup)`
  ${Text} {
    margin-top: 0;
  }
`;
